package com.macrofocus.high_d.table

data class Column(var label: String?)
